import { Routes } from '@angular/router';
import { canActivateAuthGuard, OktaCallbackComponent } from '@okta/okta-angular';
import { oktaGroupGuard } from './app-core/guards/okta-group.guard';
import { supervisorGuard } from './app-core/guards/role.guard';

export const APP_TITLE = 'Oceny DL';

export const routes: Routes = [
  {
    path: 'login/callback',
    component: OktaCallbackComponent
  },
  {
    path: 'home',
    loadComponent: () => import('./components/pages/home/home.component'),
    title: `${APP_TITLE} | Start`,
    canActivate: [canActivateAuthGuard],
  },
  {
    path: 'employee-dashboard',
    loadComponent: () => import('./components/pages/employee-dashboard/employee-dashboard.component'),
    title: `${APP_TITLE} | Moja ocena`,
    canActivate: [canActivateAuthGuard],
  },
  {
    path: 'supervisor-dashboard',
    loadComponent: () => import('./components/pages/supervisor-dashboard/supervisor-dashboard.component'),
    title: `${APP_TITLE} | Oceny pracowników`,
    canActivate: [canActivateAuthGuard, supervisorGuard],
  },
  {
    path: 'hr-dashboard',
    loadComponent: () => import('./components/pages/hr-dashboard/hr-dashboard.component'),
    title: `${APP_TITLE} | Dział personalny`,
    canActivate: [canActivateAuthGuard, oktaGroupGuard],
    data: {
      expectedGroup: [
        'IAM_DLAssessments_DEV_ADMIN',
        'IAM_DLAssessments_STG_ADMIN',
        'IAM_DLAssessments_PRD_ADMIN',
      ]
    }
  },
  {
    path: 'reader',
    loadComponent: () => import('./components/pages/reader/reader.component'),
    title: `${APP_TITLE} | Skaner`,
    canActivate: [canActivateAuthGuard, oktaGroupGuard],
    data: {
      expectedGroup: [
        'IAM_DLAssessments_DEV_ADMIN',
        'IAM_DLAssessments_STG_ADMIN',
        'IAM_DLAssessments_PRD_ADMIN',
      ]
    }
  },
  {
    path: 'assessment/:id',
    loadComponent: () => import('./components/pages/assessment/assessment.component'),
    title: `${APP_TITLE} | Ocena`,
    canActivate: [canActivateAuthGuard],
  },
  {
    path: 'help',
    loadComponent: () => import('./app-core/ui/core/sidenav/help/help.component'),
    title: `${APP_TITLE} | Pomoc`,
    canActivate: [canActivateAuthGuard],
  },
  {
    path: 'help/:item',
    loadComponent: () => import('./app-core/ui/core/sidenav/help/help.component'),
    title: `${APP_TITLE} | Pomoc`,
    canActivate: [canActivateAuthGuard],
  },
  {
    path: 'notifications',
    loadComponent: () => import('./app-core/ui/core/sidenav/notification/notification.component'),
    title: `${APP_TITLE} | Powiadomienia`,
    canActivate: [canActivateAuthGuard],
  },
  {
    path: 'preferences',
    loadComponent: () => import('./app-core/ui/core/sidenav/account/account.component'),
    title: `${APP_TITLE} | Konto`,
    canActivate: [canActivateAuthGuard],
  },
  {
    path: 'settings',
    loadChildren: () => import('./components/pages/settings/routes'),
    title: `${APP_TITLE} | Ustawienia`,
    canActivate: [canActivateAuthGuard, oktaGroupGuard],
    data: {
      expectedGroup: [
        'IAM_DLAssessments_DEV_ADMIN',
        'IAM_DLAssessments_STG_ADMIN',
        'IAM_DLAssessments_PRD_ADMIN',
      ]
    }
  },
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full'
  },
];
